import styled, { css } from 'styled-components';
import { StyledPieChartProps } from './types';
import { ChartContainer } from '../ChartContainer';
import { Theme } from '@redsift/design-system';

/**
 * Component style.
 */
export const StyledPieChart = styled(ChartContainer)<StyledPieChartProps>`
  .redsift-piechart__chart-wrapper {
    position: relative;
  }
`;

export const StyledPieChartCenterText = styled.div<{
  $maxWidth: number;
  $textSize: number;
  $smallTextSize: number;
  $theme: Theme;
}>`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  pointer-events: none;

  > * {
    max-width: ${({ $maxWidth }) => $maxWidth}px;
  }

  > b {
    font-family: var(--redsift-typography-font-family-poppins);
    color: ${({ $theme }) => `var(--redsift-color-${$theme}-components-text-primary)`};
    font-weight: var(--redsift-typography-font-weight-medium);
    font-size: ${({ $textSize }) => $textSize}px;
    line-height: ${({ $textSize }) => $textSize}px;

    &:nth-child(2) {
      font-weight: normal;
      margin-top: 8px;
      font-family: var(--redsift-typography-font-family-poppins);
      font-size: ${({ $smallTextSize }) => $smallTextSize}px;
      line-height: ${({ $smallTextSize }) => $smallTextSize}px;
    }
  }
  > span {
    color: ${({ $theme }) => `var(--redsift-color-${$theme}-components-text-primary)`};
    font-size: ${({ $textSize }) => $textSize}px;
    line-height: ${({ $textSize }) => $textSize}px;
    &:nth-child(3) {
      margin-top: 4px;
      font-size: ${({ $smallTextSize }) => $smallTextSize}px;
      line-height: ${({ $smallTextSize }) => $smallTextSize}px;
    }
  }
  > b + span {
    font-size: var(--redsift-typography-body-font-size);
    font-family: var(--redsift-typography-font-family-poppins);
    line-height: var(--redsift-typography-badge-line-height);
    color: ${({ $theme }) => ($theme === Theme.light ? 'rgba(0, 0, 0, 0.6)' : 'rgba(255, 255, 255, 0.6)')};
    text-align: center;
  }
`;

export const StyledPieChartEmptyText = styled.div<{
  $maxWidth: number;
  $textSize: number;
  $isDonut: boolean;
  $theme: Theme;
}>`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  pointer-events: none;

  > * {
    max-width: ${({ $maxWidth }) => $maxWidth}px;
  }

  > span {
    font-family: var(--redsift-typography-font-family-poppins);
    color: ${({ $isDonut, $theme }) =>
      $isDonut
        ? css`var(--redsift-color-neutral-mid-grey)`
        : css`var(--redsift-color-${$theme}-components-text-primary)`};
    font-size: ${({ $textSize }) => $textSize}px;
    line-height: ${({ $textSize }) => $textSize}px;
  }
`;
